import { useRef } from "react";
import { useEffect, useState } from "react";
import Checkbox from "@mui/material/Checkbox";
import EditIcon from "@mui/icons-material/Edit";
import FormGroup from "@mui/material/FormGroup";
import EditDescription from "./EditDescription";
import { Grid, Typography, Skeleton } from "@mui/material";
import { useSelector } from "react-redux";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import FormControlLabel from "@mui/material/FormControlLabel";
import AddNewDescriptionModal from "./AddNewDescriptionModal";

const Description = ({ data, templateId, categoryId, lineUuid, onUpdate }) => {
  const latestInspectionResponseRef = useRef();
  const [loader, setLoader] = useState(false);
  const [descriptionData, setDescriptionData] = useState();
  const [inspectionResponse, setInspectionResponse] = useState();
  const [showAddDescModal, setShowAddDesModal] = useState(false);
  const [editDescriptionModal, setEditDescriptionModal] = useState(false);

  // Redux state
  const storeData = useSelector((state) => state.CommonReducer);

  const handleClick = (e, item) => {
    const updatedValues = descriptionData.values.map((el) =>
      el.uuid === item.uuid
        ? {
          ...el,
          is_selected: !el.is_selected,
          updated_at: new Date().toISOString().replace("T", " ").substring(0, 19),
        }
        : el
    );

    setDescriptionData((prev) => ({
      ...prev,
      values: updatedValues,
    }));

    if (typeof onUpdate === 'function') {
      onUpdate(updatedValues);
    }
  };

  useEffect(() => {
    if (storeData.inspectionData?.data) {
      latestInspectionResponseRef.current = storeData;
      setInspectionResponse(storeData);
      setLoader(false);
    }
  }, [storeData.inspectionData?.data]);

  useEffect(() => {
    if (data === undefined) setDescriptionData();
    if (data) {
      let finalArray = [];
      let pullData = data;
      for (let item of pullData?.values) {
        if (item?.is_deleted === undefined) {
          item.is_deleted = 0;
        }
        finalArray.push(item);
      }
      pullData.values = finalArray;
      setDescriptionData(pullData);
    }
  }, [data]);

  return (
    <>
      <AddNewDescriptionModal
        showAddDescModal={showAddDescModal}
        setShowAddDesModal={setShowAddDesModal}
        descriptionData={descriptionData}
        editDescriptionModal={editDescriptionModal}
        setEditDescriptionModal={setEditDescriptionModal}
        inspectionResponse={inspectionResponse}
        templateId={templateId}
        categoryId={categoryId}
        lineUuid={lineUuid}
        isAdditionalInfo={false}
        currentAdditionalInputID={null}
        data={data}
      />

      {editDescriptionModal && (
        <EditDescription
          setEditDescriptionModal={setEditDescriptionModal}
          setDescriptionData={setDescriptionData}
          editDescriptionModal={editDescriptionModal}
          descriptionData={descriptionData}
          setShowAddDesModal={setShowAddDesModal}
          data={data}
          showAddDescModal={showAddDescModal}
          isAdditionalInfo={false}
          inspectionResponse={inspectionResponse}
          templateId={templateId}
          categoryId={categoryId}
          lineUuid={lineUuid}
        />
      )}

      {data?.is_disabled !== 1 ? (
        <Grid container className="container">
          <Grid item xs={12} className="line_detail_des_title">
            <span className="details_title">{data === undefined ? "Description" : data?.prompt === null ? "" : data?.prompt}</span>
            <span className="details_action" id="edit_description" onClick={() => setEditDescriptionModal(true)}>
              <EditIcon />
              Edit
            </span>
          </Grid>

          {descriptionData?.values
            ?.filter((item) => item?.is_deleted === 0)
            ?.map((item, index) => (
              <Grid item xs={6} md={storeData?.reportSideBarActive ? 6 : 4} key={index}>
                <FormGroup>
                  <FormControlLabel
                    className="checkbox flex_start"
                    control={
                      loader ? (
                        <div style={{ padding: "8px 10px 8px 8px", height: "37.5px", width: "34px", marginLeft: "3px" }}><Skeleton variant="square" sx={{ borderRadius: "3px", mt: "2px" }} /></div> // Skeleton for checkbox
                      ) : (
                        <Checkbox
                          sx={{
                            height: "37.5px !important",
                            width: "37.5px !important",
                            "& .MuiSvgIcon-root": { fontSize: "20px !important" },
                          }}
                          checked={item.is_selected}
                          onClick={(e) => handleClick(e, item)}
                        />
                      )
                    }
                    label={item.value}
                  />
                </FormGroup>
              </Grid>
            ))}
          <Grid item xs={12}>
            <Typography className="line_details__add_btn" id="add_new_description" onClick={() => setShowAddDesModal(true)}>
              <AddCircleIcon />
              <span className="line_details__add_text">Add new </span>
            </Typography>
          </Grid>
        </Grid>
      ) : (
        ""
      )}
    </>
  );
};

export default Description;
